import { Grid, CircularProgress, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import { ExternalLinkType } from '../../enums';
import ModelViewerLine from './ModelViewerLine';
import Carousel from './Carousel';
import { ApiHelper } from '../../common/ApiHelper';

const VideosAndImagesSection = ({ supportingLinksWithVideoOrImages, externalRedirectUrl }) => {
  const [items, setItems] = useState([]);
  const generateList = async () => {
    const list = supportingLinksWithVideoOrImages;
    if (supportingLinksWithVideoOrImages.length > 0) {
      // const response = await ApiHelper.GetScreenshotByUrl(externalRedirectUrl);
      // if (response.status === 200 && response.data) {
      //   // setImageLoading(false);
      //   // setImageData(response.data);
      // }
      const officialLink = {
        linkType: 'Official',
        url: externalRedirectUrl,
      };
      const alreadyExists = list.find((l) => l.linkType === 'Official');
      if (!alreadyExists) {
        list.push(officialLink);
      }
      setItems(list);
    }
  };
  useEffect(() => {
    generateList();
  }, []);
  return (
    <>
      <Carousel cards={items} type="videoOrImage" />
      <ModelViewerLine />
    </>
  );
};

export default VideosAndImagesSection;
